// this is an autogenerated file from DesignSystem/Report/ReportTable/Pending/data.graphql
import { gql } from 'Data/Api'

export default gql`
subscription app__DesignSystem_Report_ReportTable_Pending($id: uuid!) {
  reports_executions_by_pk(id: $id) {
    id
    status
    url
    created_at
    filters
    message
  }
}

`